import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	upgrade: {
		defaultMessage: 'Upgrade',
		id: 'jira-edition-awareness-for-standard-to-premium.standard-to-premium-pub-touchpoint.menu.upgrade',
		description: 'Title for persisted upgrade button menu section',
	},
});
